/**
 * Публикация строк диалогов, видимых в C-01 (CLIENT_WEB §6.7).
 *
 * Набор нужен серверу для presence-подписки. Ведомая вкладка
 * передаёт его лидеру, поэтому метка обновляется быстрее её TTL.
 */
import { syncEngine } from '@shared/sync/instance'

export const VISIBLE_CONVERSATIONS_REFRESH_MS = 45_000

let visibleConversationIds: string[] = []
let refreshTimer: ReturnType<typeof setInterval> | null = null

function effectiveIds(): readonly string[] {
  if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return []
  return visibleConversationIds
}

function publish(): void {
  syncEngine()?.setVisibleConversations(effectiveIds())
}

/** Экран C-01 передаёт полную замену текущего viewport. */
export function setVisibleConversations(ids: readonly string[]): void {
  visibleConversationIds = [...new Set(ids)].slice(0, 50)
  publish()
}

/** Обновляет remote hint и перепубликует его после foreground. */
export function startVisibleConversationsMirror(): () => void {
  const onVisibility = (): void => publish()
  document.addEventListener('visibilitychange', onVisibility)
  globalThis.addEventListener('focus', onVisibility)
  globalThis.addEventListener('blur', onVisibility)
  publish()

  refreshTimer = setInterval(() => {
    if (effectiveIds().length) publish()
  }, VISIBLE_CONVERSATIONS_REFRESH_MS)

  return () => {
    document.removeEventListener('visibilitychange', onVisibility)
    globalThis.removeEventListener('focus', onVisibility)
    globalThis.removeEventListener('blur', onVisibility)
    if (refreshTimer) clearInterval(refreshTimer)
    refreshTimer = null
    visibleConversationIds = []
    publish()
  }
}
